import React from "react";
import { ThemeContextInterface } from "./SharedModel";

const defaultState = {
  themeName: '',
  modifyTheme: () => {},
};

const ThemeContext = React.createContext<ThemeContextInterface>(defaultState);

export { ThemeContext };
